import { line, curveNatural, max, min, select } from "d3";
import { useRef, useEffect } from "react";

export const RelativeHumidity = ({
  data,
  xScale,
  yScale,
  xValue,
  yValue,
  percentage,
  returnClipPathLine,
  isSmallScreen,
}) => {
  const ref100 = useRef();
  let element100;
  useEffect(() => {
    if (percentage === 100) {
      element100 = select(ref100.current);
      returnClipPathLine(element100.attr("d"));
    }
  }, [data, percentage]);

  return (
    <g>
      //className="marks"
      <path
        //id="clip-path"

        ref={ref100}
        clipPath="url(#clip-path)"
        //clip-path="url(#myClip)"
        fill="none"
        stroke="#5a99a7"
        strokeWidth={
          isSmallScreen
            ? (percentage === 100 || percentage === 50) && "1"
            : (percentage === 100 || percentage === 50) && "2"
        }
        d={line()
          .x((d) => xScale(xValue(d)))
          .y((d) => yScale(yValue(d)))
          .curve(curveNatural)(
          data.filter((row) => row.relativeHumidity === percentage)
        )}
      >
        <title>{"Relative humidity: " + percentage + " %"}</title>
      </path>
      {Number(String(percentage)[0]) % 2 === 0 || percentage === 100 ? (
        <></>
      ) : (
        <text
          //className="textHumidity"
          font-family="Poppins, sans-serif"
          fontSize={isSmallScreen ? 8 : 16}
          fill="#5a99a7"
          x={xScale(
            max(
              data.filter((row) => row.relativeHumidity === percentage),
              (d) => xValue(d)
            )
          )}
          y={yScale(
            max(
              data.filter((row) => row.relativeHumidity === percentage),
              (d) => yValue(d)
            )
          )}
          transform={isSmallScreen ? "translate(-25 5)" : "translate(-50 15)"}
        >
          {percentage}%
        </text>
      )}
    </g>
  );
};
